import { Capacitor } from '@capacitor/core';

// True when running inside the native iOS/Android (Capacitor) app; false on the
// web app. Used to hide the App Store / Play Store download badges when the user
// is already in the app, so they aren't prompted to download it.
export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch (_) {
    return false;
  }
}
